<template>
  <div class="clinic-dashboard w-100">
    <div class="row mb-8">
      <div class="col-xl-3 col-md-6 mb-5">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body d-flex flex-column">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <span
                class="svg-icon svg-icon-primary svg-icon-3x"
                style="
                  width: 32px;
                  height: 32px;
                  border-radius: 8px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01645A" class="bi bi-credit-card-2-back" viewBox="0 0 16 16">
                <path d="M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5z"/>
                <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm13 2v5H1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1m-1 9H2a1 1 0 0 1-1-1v-1h14v1a1 1 0 0 1-1 1"/>
              </svg>
              </span>
            </div>
            <div class="font-weight-bolder font-size-h4 text-dark mb-2">
              {{ formatCurrency(overview.revenue) }}
            </div>
            <div class="text-muted font-weight-bold font-size-sm">
              Tổng doanh thu
            </div>
          </div>
        </div>
      </div>

      <!-- Active Packages -->
      <div class="col-xl-3 col-md-6 mb-5">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body d-flex flex-column">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <span
                class="svg-icon svg-icon-success svg-icon-3x"
                style="
                  width: 32px;
                  height: 32px;
                  border-radius: 8px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01645A" class="bi bi-people" viewBox="0 0 16 16">
                  <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/>
                </svg>
              </span>
            </div>
            <div class="font-weight-bolder font-size-h4 text-dark mb-2">{{ overview.serviceActive }}</div>
            <div class="text-muted font-weight-bold font-size-sm">
              Gói đang hoạt động
            </div>
          </div>
        </div>
      </div>

      <!-- Available Bundles -->
      <div class="col-xl-3 col-md-6 mb-5">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body d-flex flex-column">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <span
                class="svg-icon svg-icon-primary svg-icon-3x"
                style="
                  width: 32px;
                  height: 32px;
                  border-radius: 8px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01645A" class="bi bi-box-seam" viewBox="0 0 16 16">
                  <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z"/>
                </svg>
              </span>
            </div>
            <div class="font-weight-bolder font-size-h4 text-dark mb-2">{{ overview.bundleActive }}</div>
            <div class="text-muted font-weight-bold font-size-sm">
              Bundle có sẵn
            </div>
          </div>
        </div>
      </div>

      <!-- Usage This Month -->
      <div class="col-xl-3 col-md-6 mb-5">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body d-flex flex-column">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <span
                class="svg-icon svg-icon-warning svg-icon-3x"
                style="
                  width: 32px;
                  height: 32px;
                  border-radius: 8px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01645A" class="bi bi-graph-up-arrow" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M0 0h1v15h15v1H0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5"/>
                </svg>
              </span>
            </div>
            <div class="font-weight-bolder font-size-h4 text-dark mb-2">{{ overview.serviceUsage }}</div>
            <div class="text-muted font-weight-bold font-size-sm">
              Lượt sử dụng tháng này
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-8">
      <h4 class="text-dark font-weight-bold mb-5">Thao tác nhanh</h4>
      <div class="row">
        <div v-if="isInsertPermission" class="col-xl-3 col-md-6 mb-5">
          <div
            class="card card-custom card-stretch gutter-b cursor-pointer hover-shadow"
            @click="createBundle"
          >
            <div class="card-body text-center py-8 ">
              <span
                class="svg-icon svg-icon-primary svg-icon-3x mb-4 d-flex "
                style="
                  width: 24px;
                  height: 24px;
                  border-radius: 12px;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01645A" class="bi bi-box-seam" viewBox="0 0 16 16">
                  <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z"/>
                </svg>
              </span>
              <div class="font-weight-bold font-size-h5 text-dark d-flex">
                Tạo Bundle mới
              </div>
            </div>
          </div>
        </div>

        <div v-if="isInsertPermission" class="col-xl-3 col-md-6 mb-5">
          <div
            class="card card-custom card-stretch gutter-b cursor-pointer hover-shadow"
            @click="registerCustomer"
          >
            <div class="card-body text-center py-8  ">
              <span
                class="svg-icon svg-icon-success svg-icon-3x mb-4 d-flex "
                style="
                  width: 24px;
                  height: 24px;
                  border-radius: 12px;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01645A" class="bi bi-people" viewBox="0 0 16 16">
                  <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/>
                </svg>
              </span>
              <div class="font-weight-bold font-size-h5 text-dark d-flex">
                Đăng ký khách hàng
              </div>
            </div>
          </div>
        </div>

        <div v-if="isInsertPermission" class="col-xl-3 col-md-6 mb-5">
          <div
            class="card card-custom card-stretch gutter-b cursor-pointer hover-shadow"
            @click="recordUsage"
          >
            <div class="card-body text-center py-8  ">
              <span
                class="svg-icon svg-icon-info svg-icon-3x mb-4 d-flex "
                style="
                  width: 24px;
                  height: 24px;
                  border-radius: 12px;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01645A" class="bi bi-graph-up-arrow" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M0 0h1v15h15v1H0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5"/>
                </svg>
              </span>
              <div class="font-weight-bold font-size-h5 text-dark d-flex">
                Ghi nhận sử dụng
              </div>
            </div>
          </div>
        </div>

        <div v-if="isInsertPermission" class="col-xl-3 col-md-6 mb-5">
          <div
            class="card card-custom card-stretch gutter-b cursor-pointer hover-shadow"
            @click="createBenefitType"
          >
            <div class="card-body text-center py-8 ">
              <span
                class="svg-icon svg-icon-primary svg-icon-3x mb-4 d-flex "
                style="
                  width: 24px;
                  height: 24px;
                  border-radius: 12px;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01645A" class="bi bi-plus-lg" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
                </svg>
              </span>
              <div class="font-weight-bold font-size-h5 text-dark d-flex">
                Tạo ưu đãi
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Registrations and Available Packages -->
    <div class="row">
      <!-- Recent Registrations -->
      <div class="col-xl-6 mb-5">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-header border-0 py-5">
            <h3 class="card-title font-weight-bolder text-dark">
              Đăng ký gần đây
            </h3>
            <div class="card-toolbar">
              <a href="#" class="btn btn-text-success btn-hover-light-success font-weight-bolder font-size-sm" @click.prevent="viewAllRegistrations">
                Xem tất cả
                <i class="fas fa-arrow-right ml-2"></i>
              </a>
            </div>
          </div>
          <div class="card-body pt-0 pb-3">
            <div class="table-responsive">
              <table class="table table-head-custom table-vertical-center">
                <tbody>
                  <tr v-for="(item, index) in recentRegistrations" :key="index">
                    <td class="pl-0" style="width: 50%">
                      <div class="font-weight-bold text-dark mb-1">
                        {{ item.tranPackage ? item.tranPackage.name : 'Không rõ gói' }}
                      </div>
                      <div class="text-muted font-size-sm">
                        Khách hàng: {{ item.accountHis ? (item.accountHis.firstName || item.accountHis.fullName || 'Không rõ') : 'Không rõ' }}
                      </div>
                      <div class="text-muted font-size-sm">
                        Ngày mua: {{ formatDate(item.startDate) }}
                      </div>
                    </td>
                    <td class="text-right pr-0">
                      <span
                        :class="item.status === 1 ? 'label-light-success' : 'label-light-danger'"
                        class="label label-lg label-inline font-weight-bolder"
                      >
                        {{ item.status === 1 ? 'Hoạt động' : 'Hết hạn' }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="recentRegistrations.length === 0">
                    <td colspan="2" class="text-center text-muted py-5">
                      Chưa có đăng ký nào
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Available Packages for Sale -->
      <div class="col-xl-6 mb-5">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-header border-0 py-5">
            <h3 class="card-title font-weight-bolder text-dark">
              Gói đang bán
            </h3>
            <div class="card-toolbar">
              <a href="#" class="btn btn-text-success btn-hover-light-success font-weight-bolder font-size-sm" @click.prevent="viewAllPackages">
                Xem tất cả
                <i class="fas fa-arrow-right ml-2"></i>
              </a>
            </div>
          </div>
          <div class="card-body pt-0 pb-3">
            <div class="table-responsive">
              <table class="table table-head-custom table-vertical-center">
                <tbody>
                  <tr v-for="(item, index) in availablePackages" :key="index">
                    <td class="pl-0" style="width: 60%">
                      <div class="font-weight-bold text-dark mb-1">
                        {{ item.name }}
                      </div>
                      <div class="text-success font-weight-bolder">
                        {{ formatCurrency(item.salePrice) }}
                      </div>
                    </td>
                    <td class="text-right pr-0">
                      <span
                        class="label label-lg label-light-success label-inline font-weight-bolder"
                      >
                        {{ computeDiscount(item) }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="availablePackages.length === 0">
                    <td colspan="2" class="text-center text-muted py-5">
                      Chưa có gói nào
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ClinicDashboard',
  data() {
    return {
      overview: {
        revenue: 0,
        serviceActive: 0,
        bundleActive: 0,
        serviceUsage: 0,
      },
      recentRegistrations: [],
      availablePackages: [],
    };
  },
  mounted() {
    this.loadDashboard();
  },
  methods: {
    async loadDashboard() {
      await Promise.all([
        this.loadOverview(),
        this.loadRecentRegistrations(),
        this.loadAvailablePackages(),
      ]);
    },

    async loadOverview() {
      try {
        const res = await this.$api.get('UserBundleOrders/dashboard/OverView');
        const data = res?.data ?? res;
        this.overview = {
          revenue: data.revenue ?? 0,
          serviceActive: data.serviceActive ?? 0,
          bundleActive: data.bundleActive ?? 0,
          serviceUsage: data.serviceUsage ?? 0,
        };
      } catch (error) {
        console.error('Lỗi tải overview:', error);
      }
    },

    async loadRecentRegistrations() {
      try {
        const res = await this.$api.get('UserBundleOrders/All');
        const raw = res?.data ?? res;
        const items = Array.isArray(raw) ? raw : (raw?.items ?? raw?.data ?? []);
        this.recentRegistrations = items.slice(0, 3);
      } catch (error) {
        console.error('Lỗi tải đăng ký gần đây:', error);
        this.recentRegistrations = [];
      }
    },

    async loadAvailablePackages() {
      try {
        const res = await this.$api.get('SalePackage/All');
        const raw = res?.data ?? res;
        const items = Array.isArray(raw) ? raw : (raw?.items ?? raw?.data ?? []);
        this.availablePackages = items.slice(0, 3);
      } catch (error) {
        console.error('Lỗi tải gói đang bán:', error);
        this.availablePackages = [];
      }
    },

    createBundle() {
      this.$router.push({ name: 'package_management' });
    },
    registerCustomer() {
      this.$router.push({ name: 'package_registration' });
    },
    recordUsage() {
      this.$router.push({ name: 'usage_recording' });
    },
    createBenefitType() {
      this.$router.push({ name: 'benefit_type_create' });
    },
    viewAllRegistrations() {
      this.$router.push({ name: 'package_registration' });
    },
    viewAllPackages() {
      this.$router.push({ name: 'package_management' });
    },
    formatCurrency(value) {
      if (!value && value !== 0) return '0 ₫';
      return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
      }).format(value);
    },
    formatDate(unixTimestamp) {
      if (!unixTimestamp) return '?';
      const ms = unixTimestamp < 1e10 ? unixTimestamp * 1000 : unixTimestamp;
      const d = new Date(ms);
      if (isNaN(d.getTime())) return '?';
      return d.toLocaleDateString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },
    computeDiscount(item) {
      if (!item.price || item.price === 0) return '';
      const discount = Math.round(((item.price - item.salePrice) / item.price) * 100);
      return discount > 0 ? `-${discount}%` : '';
    },
  },
};
</script>

<style scoped>
.clinic-dashboard {
  padding: 20px;
}

.cursor-pointer {
  cursor: pointer;
}

.hover-shadow:hover {
  box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.15);
  transition: all 0.3s ease-in-out;
}

.card-custom {
  transition: all 0.3s ease-in-out;
}
</style>